import React, { Component, useContext } from 'react';
import {BrowserRouter, Routes, Route} from 'react-router-dom';

import './App.css';

//---- Pages
import UltraStreamLoading from './routes/loading';
import UltraStreamTemplate from './routes/index';
//import Login from './routes/login';

//---- Components
import {UserContext, UserProvider} from './utils/usercontext';
import Socket from './utils/socket';

//---- CSS
import 'bootstrap/dist/css/bootstrap.min.css';


const Loading = (props) => {
  const value = useContext(UserContext);
  if( !value.user.user ) {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="*" element={<UltraStreamLoading />} />
        </Routes>
      </BrowserRouter>
    )
  } else {
    return (
      <>
        {props.children}
      </>
    )
  }
}

export default class App extends Component {
  render() {
    return (
      <div style={{height: "100%"}}>
        <UserProvider>
          <Loading>
            <BrowserRouter>
              <Routes>
                <Route path="/" exact element={<UltraStreamTemplate />} />
                <Route path="/:id" element={<UltraStreamTemplate />} />
              </Routes>
              <Socket />
            </BrowserRouter>
          </Loading>
        </UserProvider>
      </div>
    );
  }
};
